/**
 * Created by jv on 12/01/2017.
 */
const utils = require("Sources/utils/utils");

var elementCreator = {};

(function(ElementCreator)
{
  ElementCreator.createStringElement = function(options)
  {
    /*
     * options.tagName = div
     * options.classNames = []
     * options.attributes = []
     * options.value = null
     */
    options.tagName = utils.isDefined(options.tagName) ? options.tagName : "div";
    options.classNames = utils.isArray(options.classNames) ? options.classNames : [];
    options.attributes = utils.isArray(options.attributes) ? options.attributes : [];
    options.innerHTML = utils.isDefined(options.innerHTML) ? options.innerHTML : null;

    var classNames = createClassNames(options.classNames);
    var attributes = createAttributes(options.attributes);

    var element = "<" + options.tagName;
    element += classNames;
    element += attributes;

    var isEmptyEl = isEmptyElement(options.tagName);

    if(isEmptyEl)
    {
      if(options.tagName === "input")
      {
        element += ">";
      }
      else
      {
        element += "/>";
      }

      return element;
    }

    element += ">";

    if(options.innerHTML !== null)
    {

      element += options.innerHTML;
    }

    element += getClosingTag(options.tagName);

    return element;
  };

  ElementCreator.arrayToAttributesString = function(attributes)
  {
    var attributeString = "";

    if(utils.isArray(attributes))
    {
      for(var i = 0; i < attributes.length; i++)
      {
        var attribute = attributes[i];
        if(attribute.hasOwnProperty("name") && attribute.hasOwnProperty("value"))
        {
          attributeString += i > 0 ? " " : "";
          attributeString += attribute.name + "='" + attribute.value + "'";
        }
      }
    }

    return attributeString;
  };

  function getClosingTag(tagName)
  {
    return "</" + tagName + ">";
  }

  function createClassNames(classNames)
  {
    var classNamesString = " class='";

    for(var i = 0; i < classNames.length; i++)
    {
      if(!utils.isNullOrEmpty(classNames[i]))
      {
        classNamesString += (i > 0 ? " " : "") + classNames[i];
      }
    }

    classNamesString += "'";

    return classNamesString;
  }

  function createAttributes(attributes)
  {
    var attributesStr = "";

    for(var i = 0; i < attributes.length; i++)
    {
      var attr = attributes[i];

      attributesStr += " " + attr.name;

      if(utils.isNotNull(attr.value))
      {
        attributesStr += "='" + attr.value + "'";
      }
    }

    return attributesStr;
  }

  function isEmptyElement(tagName)
  {
    var emptyElements = [ "input", "img", "svg", "br", "base", "br", "col", "embed", "hr", "link", "meta", "param", "source", "track", "wbr" ];

    return $.inArray(tagName, emptyElements) !== -1;
  }
}(elementCreator));

module.exports = elementCreator;



// WEBPACK FOOTER //
// ./app/js/components/element-creator.js